import React from "react";
import { useState, useEffect, useRef } from "react";
import PerfectScrollbar from "react-perfect-scrollbar";
import { Link } from "react-router-dom";
import {
  Box,
  Button,
  ButtonGroup,
  Card,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TablePagination,
  TableContainer,
} from "@mui/material";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
import Chip from "@mui/material/Chip";
import SearchField from "react-search-field";
import Typography from "@mui/material/Typography";
import Option from "./Option";

const delay = 5;

const options = [
  { id: 1, name: "Lab Name", value: "name" },
];

const LabList = ({ ...rest }) => {
  const [instancelist, setinstancelist] = useState([]);
  function DateTime1(startDate, startTime) {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    // const startDate1 = new Date(startDate).toLocaleString("en-GB", {
    //   timeZone: `${timezone}`,
    // });
    const startDate1 = new Date(startDate + "T" + startTime + ":00.000Z").toLocaleString("en-GB", { timeZone: `${timezone}` });
    const startDate2 = startDate1.split(",");
    const startDatef = startDate2[0].replace("/", "-");
    const startDate3 = startDatef.replace("/", "-");

    const startTime1 = new Date(
      startDate + "T" + startTime + ":00.000Z"
    ).toLocaleString("en-GB", { timeZone: `${timezone}` });
    // console.log("checking with starttime--->", startTime1)
    const startTime2 = startTime1.split(",");
    const startTime3 = startTime2[1].substring(0, 6);

    const startDateTime = startDate3 + "" + startTime3;

    return startDateTime;
  }

  function DateTime2(endDate, endTime) {
    if (!endDate || !endTime) {
      return "Invalid Date";
    }
  
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const parsedDate = new Date(endDate);
    if (isNaN(parsedDate)) return "Invalid Date";
  
    const endDateStr = parsedDate.toLocaleString("en-GB", { timeZone: timezone });
    const endDateParts = endDateStr.split(",");
    if (endDateParts.length < 2) return "Invalid Date";
  
    const formattedEndDate = endDateParts[0].replace(/\//g, "-");
  
    const parsedDateTime = new Date(`${endDate}T${endTime}:00.000Z`);
    if (isNaN(parsedDateTime)) return "Invalid Date";
  
    const endTimeStr = parsedDateTime.toLocaleString("en-GB", { timeZone: timezone });
    const endTimeParts = endTimeStr.split(",");
  
    // Ensure we have a valid time part before using substring
    const formattedEndTime = endTimeParts[1]?.trim().substring(0, 5) || "00:00";
  
    return `${formattedEndDate} ${formattedEndTime}`;
  }

  useEffect(() => {
    let isMounted = true;
    let intervalId;
  
    const fetchData = () => {
      fetch(`${process.env.REACT_APP_API_URL}/api/getmanuallabdetails/`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
        .then((resp) => resp.json())
        .then((data) => {
          if (isMounted) {
            setinstancelist(data);
          }
        })
        .catch((error) => console.error(error));
    };
  
    fetchData();
    intervalId = setInterval(fetchData, 1000);
  
    return () => {
      isMounted = false;
      clearInterval(intervalId); // Stop fetching when unmounted
    };
  }, []);
  
  
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const emptyRows =
    rowsPerPage -
    Math.min(rowsPerPage, instancelist.length - page * rowsPerPage);

  const [anchorEl, setAnchorEl] = React.useState(null);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  const id = open ? "simple-popover" : undefined;

  const [selectedIndex, setSelectedIndex] = React.useState(0);

  const handleMenuItemClick = (event, index) => {
    setSelectedIndex(index);
  };

  const [searchitems, setSearchItems] = React.useState(0);

  return (
    <>
      <Box style={{ marginTop: "-30px"}} >
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
          <Typography
            sx={{ flex: "1 1 100%" }}
            style={{
              fontSize: "x-large",
              lineHeight: "2.5",
              paddingLeft: "24px",
            }}
            color="textPrimary"
            variant="body1"
          >
            Manual
          </Typography>
        </Box>
        <Box sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center", marginTop: "-20px", marginBottom: "10px", paddingX: "10px", '@media (max-width: 768px)': { flexDirection: 'column', marginTop: 0 } }}>
        <SearchField
          value={searchitems}
          placeholder="Search by Lab Name"
          onChange={(newValue) => setSearchItems(newValue)}
          classNames="test-class"
        />
        </Box>
      </Box>
      <Box sx={{ pt: 1 }}>
        <Card {...rest}>
          <PerfectScrollbar>
            <Box sx={{ minWidth: 1000 }}>
              <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell align="center">Lab Name</TableCell>
                      <TableCell align="center">Number of Trainee</TableCell>
                      <TableCell align="center">Status</TableCell>
                      <TableCell align="center">Lab ID</TableCell>
                      <TableCell align="center">Start Duration</TableCell>
                      <TableCell align="center">End Duration</TableCell>
                      <TableCell align="center">Actions</TableCell>
                      <TableCell align="center">Details</TableCell>
                    </TableRow>
                  </TableHead>
                  {instancelist.length > 0 ? (
                    <TableBody>
                      {instancelist
                        .filter((val) => {
                          if (searchitems == "") {
                            return val;
                          } else if (
                            val[options[selectedIndex].value]
                              .toLowerCase()
                              .includes(searchitems.toLowerCase())
                          ) {
                            return val;
                          }
                        })
                        .slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage
                        )
                        .map((instance) => (
                          <TableRow hover key={instance.id}>
                            <TableCell align="center">
                              {instance.name}
                            </TableCell>
                            <TableCell align="center">
                                {instance.number_of_trainee}
                            </TableCell>
                            <TableCell align="center">
                              {instance.status === "Creating" ? (
                                <Chip
                                  color="primary"
                                  label={instance.status}
                                  size="small"
                                />
                              ) : instance.status === "Scheduled" ? (
                                <Chip
                                  color="primary"
                                  style={{ backgroundColor: "rgb(44 189 186)" }}
                                  label={instance.status}
                                  size="small"
                                />
                              ) : instance.status === "Running" ? (
                                <Chip
                                  color="primary"
                                  style={{ backgroundColor: "#00a200" }}
                                  label={instance.status}
                                  size="small"
                                />
                              ) : instance.status === "Stopped" ? (
                                <Chip
                                  color="primary"
                                  style={{
                                    backgroundColor: "rgb(228 193 3 / 94%)",
                                  }}
                                  label={instance.status}
                                  size="small"
                                />
                              ) : instance.status === "Cordoned" ? (
                                <Chip
                                  color="primary"
                                  style={{
                                    backgroundColor: "rgb(98 95 80 / 94%)",
                                  }}
                                  label={instance.status}
                                  size="small"
                                />
                              ) : (
                                <Chip
                                  color="primary"
                                  style={{
                                    backgroundColor: "rgb(228 3 3 / 94%)",
                                  }}
                                  label={instance.status}
                                  size="small"
                                />
                              )}
                            </TableCell>
                            <TableCell align="center">{instance.id}</TableCell>
                            {instance.start_time === "" ||
                            instance.start_time === null ? (
                              <TableCell align="center">NA</TableCell>
                            ) : (
                              <TableCell align="center">
                                {DateTime1(
                                  `${instance.start_date}`,
                                  `${instance.start_time}`
                                )}
                              </TableCell>
                            )}
                            {instance?.stop_time && instance?.end_date ? (
                              <TableCell align="center">
                                {DateTime2(instance.end_date, instance.stop_time)}
                              </TableCell>
                            ) : (
                              <TableCell align="center">NA</TableCell>
                            )}

                            <TableCell align="center">
                              <Option
                                InstanceID={instance.id}
                                name={instance.name}
                                count={instance.number_of_trainee}
                                status={instance.status}
                                spent={instance.spent}
                                budget={instance.budget}
                              />
                            </TableCell>
                            <TableCell align="center">
                              <Button size="sm">
                                  <Link
                                    to={{
                                      pathname:
                                        "/app/manualedit",
                                    }}
                                    onClick={() => {
                                      localStorage.setItem(
                                        "InstanceID",
                                        instance.id
                                      );
                                    }}
                                    style={{ color: "#FFF" }}
                                  >
                                    <ArrowRightAltIcon color="primary" />
                                  </Link>
                                </Button>
                            </TableCell>
                          </TableRow>
                        ))}
                    </TableBody>
                  ) : (
                    <TableBody align="center">
                      <TableCell align="center">No Data Available</TableCell>
                    </TableBody>
                  )}
                </Table>
              </TableContainer>
              {instancelist.length > 0 ? (
                <Box sx={{ display: 'flex', justifyContent: 'flex-start', paddingLeft: '20px' }}>
                  <TablePagination
                    rowsPerPageOptions={[5, 10, 25]}
                    component="div"
                    count={instancelist.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                  />
                </Box>
              ) : (
                ""
              )}
            </Box>
            <Divider />
          </PerfectScrollbar>
        </Card>
      </Box>
    </>
  );
};

export default LabList;
